import { defineStore } from 'pinia'
import { ref } from 'vue'
import { OrderNotificationsService } from '@/services/order-notifications.service'
import type { Notification } from '@/entities/notification'

const service = new OrderNotificationsService();

export const useOrderNotificationStore = defineStore('orderNotification', () => {
  const notifications = ref<Notification[]>([])

  async function fetchNotifications(forceUpdate = false): Promise<void> {
    try {
      const result = await service.getNotifications(forceUpdate)
      if (result) {
        notifications.value = result
      }
    } catch (error) {
      console.warn('Error while fetching notifications');
    }
  }

  function setNotifications(data: Notification[]) {
    notifications.value = [...data]
  }

  return {
    notifications,
    fetchNotifications,
    setNotifications,
  }
})

